import React from "react";
import Layout from "./../components/Layout/Layout";
import {
  Box,
  Typography,
} from '@mui/material'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import "../styles/HomeStyles.css";

const Privacy = () => {
  return (
    <Layout>
      <Box className="home" width="100%" sx={{ textAlign: "center", my:5}}>
        <Typography variant="h4">ivm9 Privacy Policy</Typography>
        <Box sx={{ textAlign: "center", mt: 5, mx: 5, "& h4": { fontWeight: "bold", mb: 0 } }}>
          <Typography>
            Last updated: July 24, 2024<br/>
            This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
          
            <br/><br/>
            We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. 

          </Typography>
          <Typography variant="h6" sx={{fontWeight:"bold", mt:3}}>Interpretation and Definitions:</Typography>
          <Box
            alignItems="center"
            sx={{
                display:"flex",
                textAlign: "center",
                m: 3,
                mx: 15,
                mb:2,
                "@media (max-width:600px)": {
                mx: 1,
                mb:2,
                },
                justifyContent: 'center'
            }}
          >
            <TableContainer component={Paper} elevation={5}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableBody>

                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="left" sx = {{fontSize: '20px', fontWeight:"bold"}}>Interpretation</TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="left">The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="left" sx = {{fontSize: '20px', fontWeight:"bold"}}>Definitions<br/><p style={{fontSize: '12px', fontWeight:'normal'}}>For the purposes of this Privacy Policy:</p></TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="left"><span style={{fontWeight: 'bold'}}>Account</span> means a unique account created for You to access our Service or parts of our Service.</TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell align="left"><span style={{fontWeight: 'bold'}}>Affiliate</span> means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell align="left"><span style={{fontWeight: 'bold'}}>Company</span> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Udvaban Technologies Pvt ltd, Plot No.83, Backside Road of NRRI Campus, Bhadimul, Cuttack. </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell align="left"><span style={{fontWeight: 'bold'}}>Cookies</span> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="left"><span style={{fontWeight: 'bold'}}>Country</span> refers to: Orissa, India
                      </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="left"><span style={{fontWeight: 'bold'}}>Device</span> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>Personal</span> Data is any information that relates to an identified or identifiable individual.</TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>Service</span> refers to the Website. </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>Service Provider</span> means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used. </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>Website</span> refers to ivm9, accessible from http://www.ivm9.co.in </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>You</span> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable. </TableCell>
                    </TableRow>
                    {/* <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="left" sx = {{fontSize: '20px', fontWeight:"bold"}}>Collecting and Using Your Personal Data</TableCell>
                    </TableRow> */}
                     </TableBody>
              </Table>
            </TableContainer>
        </Box>
        <Typography variant="h6" sx={{fontWeight:"bold", mt:0}}>Collecting and Using Your Personal Data:<p style={{fontSize: '12px', fontWeight:'normal'}}>Types of Data Collected</p></Typography>
        <Box
        alignItems="center"
        sx={{
            display:"flex",
            textAlign: "center",
            m: 3,
            mx: 15,
            mb:2,
            "@media (max-width:600px)": {
            mx: 1,
            mb:2,
            },
            justifyContent: 'center'
        }}
        >
            <TableContainer component={Paper} elevation={5}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableBody>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="center" sx = {{fontSize: '20px', fontWeight:"bold"}}>Personal Data</TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left">While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:
                        Email address
                        First name and last name
                        Phone number
                    </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="center" sx = {{fontSize: '20px', fontWeight:"bold"}}>Use of Your Personal Data<p style={{fontSize: '12px', fontWeight:'normal'}}>The Company may use Personal Data for the following purposes:</p></TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>To provide and maintain our Service,</span> including to monitor the usage of our Service.
                     </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>To manage Your Account:</span> to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user. </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>For the performance of a contract:</span> the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service. </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>To contact You:</span> To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation. </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>To provide You</span> with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information. </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>To manage Your requests:</span> To attend and manage Your requests to Us. </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>For business transfers:</span> We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred. </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>For other purposes:</span> We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience. </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="center" sx={{fontWeight:'bold'}}>We may share Your personal information in the following situations:</TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>With Service Providers:</span> We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to contact You. </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>For business transfers:</span> We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company. </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>With business partners:</span> We may share Your information with Our business partners to offer You certain products, services or promotions. </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>With Your consent:</span> We may disclose Your personal information for any other purpose with Your consent. </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="center" sx = {{fontSize: '20px', fontWeight:"bold"}}>Retention of Your Personal Data</TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left">The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies. </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left">The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods. </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="center" sx = {{fontSize: '20px', fontWeight:"bold"}}>Transfer of Your Personal Data</TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left">Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction. </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left">Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer. </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left">The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information. </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="center" sx = {{fontSize: '20px', fontWeight:"bold"}}>Delete Your Personal Data</TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left">You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You. </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left">Our Service may give You the ability to delete certain information about You from within the Service. </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left">You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us. </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left">Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so. </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="center" sx = {{fontSize: '20px', fontWeight:"bold"}}>Disclosure of Your Personal Data</TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>Business Transactions:</span> If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy. </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left"><span style={{fontWeight: 'bold'}}>Law enforcement:</span> Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency). </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell align="left"><span style={{fontWeight: 'bold'}}>Other legal requirements</span>
                            The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:
                            Comply with a legal obligation
                            Protect and defend the rights or property of the Company
                            Prevent or investigate possible wrongdoing in connection with the Service
                            Protect the personal safety of Users of the Service or the public
                            Protect against legal liability 
                        </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="center" sx = {{fontSize: '20px', fontWeight:"bold"}}>Security of Your Personal Data</TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell align="left">The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.</TableCell>
                    </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
        </Box>

        <Typography variant="h6" sx={{fontWeight:"bold", mt:0}}>Children's Privacy:</Typography>
        <Box
        alignItems="center"
        sx={{
            display:"flex",
            textAlign: "center",
            m: 3,
            mx: 15,
            mb:2,
            "@media (max-width:600px)": {
            mx: 1,
            mb:2,
            },
            justifyContent: 'center'
        }}
        >
            <TableContainer component={Paper} elevation={5}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableBody>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell align="left">Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.</TableCell>
                    </TableRow>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left">If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information.</TableCell>
                    </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
        </Box>

        <Typography variant="h6" sx={{fontWeight:"bold", mt:0}}>Links to Other Websites:</Typography>
        <Box
        alignItems="center"
        sx={{
            display:"flex",
            textAlign: "center",
            m: 3,
            mx: 15,
            mb:2,
            "@media (max-width:600px)": {
            mx: 1,
            mb:2,
            },
            justifyContent: 'center'
        }}
        >
            <TableContainer component={Paper} elevation={5}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableBody>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left">Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.</TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left">We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</TableCell>
                    </TableRow>
                    </TableBody>
              </Table>
            </TableContainer>
        </Box>

        <Typography variant="h6" sx={{fontWeight:"bold", mt:0}}>Changes to this Privacy Policy:</Typography>
        <Box
        alignItems="center"
        sx={{
            display:"flex",
            textAlign: "center",
            m: 3,
            mx: 15,
            mb:2,
            "@media (max-width:600px)": {
            mx: 1,
            mb:2,
            },
            justifyContent: 'center'
        }}
        >
            <TableContainer component={Paper} elevation={5}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableBody>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left">We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page. </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left">We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy. </TableCell>
                    </TableRow><TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left">You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</TableCell>
                    </TableRow>
                    </TableBody>
              </Table>
            </TableContainer>
        </Box>

        <Typography variant="h6" sx={{fontWeight:"bold", mt:0}}>Contact Us:</Typography>
        <Box
        alignItems="center"
        sx={{
            display:"flex",
            textAlign: "center",
            m: 3,
            mx: 15,
            mb:20,
            "@media (max-width:600px)": {
            mx: 1,
            mb:15,
            },
            justifyContent: 'center'
        }}
        >
            <TableContainer component={Paper} elevation={5}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableBody>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                     <TableCell align="left">If you have any questions about this Privacy Policy, You can contact us: ezibees8@gmail.com</TableCell>
                    </TableRow>
                   
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default Privacy;